import apiClient from './api'
import { CURRENCY_LIST } from '../constants/currencies'

function normalizeCurrencyCode(value) {
  const normalized = String(value || '').trim().toUpperCase()
  return /^[A-Z]{3}$/.test(normalized) ? normalized : null
}

function normalizeCurrencyCatalog(response) {
  const data = response?.data?.data || response?.data || {}
  const currencies = Array.isArray(data?.currencies) ? data.currencies : []
  const normalizedCurrencies = []
  const seen = new Set()

  for (const item of currencies) {
    const currency = normalizeCurrencyCode(item)
    if (!currency || seen.has(currency)) continue
    seen.add(currency)
    normalizedCurrencies.push(currency)
  }

  const catalogCurrencies = normalizedCurrencies.length > 0 ? normalizedCurrencies : [...CURRENCY_LIST]

  return {
    currencies: catalogCurrencies,
    source: String(data?.source || 'shared/currencies.json'),
    count: Number(data?.count || catalogCurrencies.length || 0),
  }
}

export function getCurrencyCatalogFallback() {
  return {
    currencies: [...CURRENCY_LIST],
    source: 'shared/currencies.json',
    count: CURRENCY_LIST.length,
  }
}

export async function getCurrencyCatalog() {
  const response = await apiClient.get('/currencies')
  return normalizeCurrencyCatalog(response)
}

const currencyCatalogService = {
  getCurrencyCatalog,
  getCurrencyCatalogFallback,
}

export default currencyCatalogService
